import { render, staticRenderFns } from "./NewDownloadGuide.vue?vue&type=template&id=ed3df1e4&scoped=true&"
import script from "./NewDownloadGuide.vue?vue&type=script&lang=js&"
export * from "./NewDownloadGuide.vue?vue&type=script&lang=js&"
import style0 from "./NewDownloadGuide.vue?vue&type=style&index=0&id=ed3df1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3df1e4",
  null
  
)

export default component.exports